<a href="javascript:void(0)" class="card-graphic-medium-wrapper">
  <mat-card class="">
    <mat-card-content >
      <div class="card-graphic-medium-content">
        <span class="text-sm text-mutted mt-10">{{label}}</span>
      </div>
      @if (graphicType && graphicType==='bar') {
        <div class="conatiner-graphic-medium">
          <ngx-charts-bar-vertical
            [view]="[250,280]"
            [results]="single"
            [gradient]="gradient"
            [xAxis]="showXAxis"
            [yAxis]="showYAxis"
            [legend]="showLegend"
            [showXAxisLabel]="showXAxisLabel"
            [showYAxisLabel]="showYAxisLabel"
            [xAxisLabel]="xAxisLabel"
            [yAxisLabel]="yAxisLabel"
            [doughnut]="true"
            (select)="onSelect($event)">
          </ngx-charts-bar-vertical>
        </div>
      }
      @if (graphicType && graphicType==='doughnut') {
        <div class="conatiner-graphic-medium">
          <ngx-charts-pie-chart
            [view]="[250,280]"
            [legend]="false"
            [labels]="false"
            [legendTitle]="''"
            [view]="[250,280]"
            [results]="single"
            [doughnut]="true">
          </ngx-charts-pie-chart>
        </div>
      }
    </mat-card-content>
  </mat-card>
</a>
